import { useState } from 'react';
import css from './index.module.scss';
import { createPortal } from 'react-dom';
import ContractorPopUp from '../ContractorPopUp';

export default function CastCardPopUp({ callback }: any) {
    const lists = [
        {
            title: 'Confirm Your Eligibility',
            desc: 'Check if your home qualifies for solar and storage rebates.',
        },
        {
            title: 'Choose a Contractor & Get Approval',
            desc: (
                <p>
                    <span
                        className="blue blue1"
                        onClick={() => {
                            setShowModal(true);
                        }}
                    >
                        Find an EcoFlow Certified Contractor
                    </span>
                    &nbsp; who can help submit the required pre-installation form. <br></br>
                    <span className="blue">*Be sure to contact the contractor before making any purchase to ensure rebate eligibility.</span>
                </p>
            ),
        },
        {
            title: 'Complete Your Upgrades',
            desc: 'Purchase your equipment and have your licensed contractor install the system.',
        },
        {
            title: 'Receive Your Rebate',
            desc: `After your contractor submits all required documentation and your application is approved, you'll receive your rebate.`,
        },
    ];
    const [showModal, setShowModal] = useState(false);
    return (
        <div
            className={`castCard-popup ${css['castCard-popup']} GtmModuleData-section`}
            data-section-id={'dpu-ApplyRebstesPopUp'}
            data-section-title={'dpu-ApplyRebstesPopUp'}
        >
            <div className="castCard-popup-content">
                <header className="castCard-popup-header">
                    <span>How to Apply Rebates</span>
                    <svg
                        className="header-close"
                        onClick={() => callback(false)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </header>
                <body className="castCard-popup-body">
                    <p className="castCard-title blue">{'How to Claim Your Solar & Battery Rebate'}</p>
                    <p className="castCard-desc">{"Based on Ontario's Home Renovation Savings Program & BC Hydro rebates"}</p>
                    <ul className="lists">
                        {lists?.map((list: any, k: number) => (
                            <li className="list" key={k}>
                                <span className="list-step">{k + 1}</span>
                                <p>
                                    <p className="list-title">{list.title}</p>
                                    <p className="list-text">{list.desc}</p>
                                </p>
                            </li>
                        ))}
                    </ul>
                </body>
            </div>
            {showModal &&
                createPortal(
                    <div>
                        <ContractorPopUp
                            callback={() => {
                                setShowModal(false);
                            }}
                        ></ContractorPopUp>
                    </div>,
                    document.body,
                )}
        </div>
    );
}
